<ng-template>
  <h1>¿Estas seguro que seas eliminar el servicio adicional?</h1>
  <button>Si</button>
  <button>No</button>
</ng-template>
